import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(private meta: Meta,private router:Router) {
    // meta.addTag({name: 'description', content: 'Title and Meta tags examples'});
  }


  setTagsPage(data){

    // this.removeTags();

    this.meta.updateTag({name: 'title', content: data.title});

    this.meta.updateTag({property: 'og:title', content: data.title});
    this.meta.updateTag({property: 'og:url', content: window.location.href});
    this.meta.updateTag({property: 'og:description', content: data.description});
    this.meta.updateTag({property: 'og:image', content: data.image});

  }

  removeTags(){

    this.meta.removeTag('property = "og:title"');
    this.meta.removeTag('property = "og:url"');
    this.meta.removeTag('property = "og:description"');
    this.meta.removeTag('property = "og:image"');
    this.meta.removeTag('property = "og:type"');

  }
}
